// extracted by mini-css-extract-plugin
export var actions = "_3n-0";
export var actionsContainer = "_3n-7";
export var border = "_3n-1";
export var childFullHeight = "_3n-f";
export var collapse = "_3n-2";
export var content = "_3n-a";
export var contentChild = "_3n-e";
export var fullscreen = "_3n-c";
export var hasLeftRadius = "_3n-k";
export var headerContainer = "_3n-3";
export var headerRow = "_3n-5";
export var hidePadding = "_3n-b";
export var navCollapsedGap = "_3n-l";
export var noScrollX = "_3n-m";
export var noScrollY = "_3n-n";
export var noTopPadding = "_3n-i";
export var optOutTopPadding = "_3n-d";
export var pageMain = "_3n-j";
export var pageOuter = "_3n-g";
export var pagePadding = "_3n-8";
export var pageScroll = "_3n-9";
export var profile = "_3n-o";
export var profileContainer = "_3n-p";
export var profileImage = "_3n-q";
export var profileMain = "_3n-r";
export var profileSubtitle = "_3n-t";
export var profileTitle = "_3n-s";
export var showLeftPadding = "_3n-h";
export var tabsPortalSlot = "_3n-6";
export var tabsWrapper = "_3n-4";
export var title = "_3n-u";